import {
  useUserContext 
} from "@/context/user"
import mergeOperations from "@/util/shallowMerge"
import {
  useMutation, useQuery 
} from "@apollo/client"
import {
  useCallback 
} from "react"
import defaultOperations from "./accountInfluencerPage.gql"

export const useAccountInfluencerPage = (props) => {
  const operations = mergeOperations(defaultOperations, props.operations)

  const {
    getCustomerInfluencerQuery, saveInfluencerMutation 
  } = operations

  const [{
    isSignedIn 
  }] = useUserContext()

  const {
    data: influencerData, loading 
  } = useQuery(
    getCustomerInfluencerQuery,
    {
      fetchPolicy: "cache-and-network",
      skip: !isSignedIn,
    }
  )

  const [
    saveInfluencer,
    {
      error: saveInfluencerError,
      loading: isSaveInfluencer,
      data: saveInfluencerData,
    },
  ] = useMutation(saveInfluencerMutation)

  const onPaypalAccountSubmit = useCallback(
    async ({
      paypal_account 
    }) => {
      try {
        await saveInfluencer({
          variables: {
            paypal_account,
          },
        })
      } catch (error) {
        console.error(error)
      }
    },
    [saveInfluencer]
  )

  return {
    influencerData: influencerData?.customer.influencer,
    onPaypalAccountSubmit,
    loading,
    isSaveInfluencer,
    saveInfluencerError,
    response: saveInfluencerData && saveInfluencerData.saveInfluencer,
  }
}
